module.exports = __webpack_public_path__ + "static/media/工程造价咨询甲级资质.6b5218ab.png";